const messages = {
  en: {
    messages: {
      articles: {
        success: "Articles successfully updated.",
        added_to_group: "Articles successfully added to group.",
        delete_label: "{count} article | {count} articles"
      },
      request: {
        error: "Something went wrong, please try again.",
        refresh_metrics_success: "Impressions and AVE successfully refreshed",
        duplicated: "Category already exists"
      },
      queries: {
        delete_success: 'Query has been successfully deleted',
        force_refresh: 'Queries Data successfully refreshed',
        run: {
          error: "Something went wrong while running your query! Please try again."
        },
        refresh_success: "Queries refresh has been successfully requested.",
        save_settings_success: "Settings updated succesfully.",
      },
      confirm_ignore: {
        title: "Confirm Ignore",
        message: "Are you sure you want to ignore?"
      },
      tags:{
        change_visibility: {
          title: 'Change Visibility',
          public: 'Are you sure you want to change the visibility of {0} to public?',
          private: 'Are you sure you want to change the visibility of {0} to private?',
        },
        organiation: {
          added_successfully: "Organization added Successfully"
        }
      },
      confirm_delete: {
        title: "Confirm Delete",
        title_selected: "Delete Selected",
        title_remove: "Confirm Remove",
        title_coder: "Remove Coder",
        title_project_from_coder: "Remove Project From Coder",
        message: "Are you sure you want to permanently delete '{0}'?",
        message_selected: "Are you sure you want to permanently delete the selected {0}?",
        tags_with_no_associated_articles: "By confirming, you will remove all tags that do not have any associated articles.",
        message_remove: "Are you sure that you want to remove {0}?",
        password_confirm_message: "To confirm this action, re-enter your CARMA password:",
        password_confirm_error: "Invalid password please try again",
        danger_message_plural: "By deleting these {0} they will be removed from the project along with all the associated codings.",
        danger_message_singular: "By deleting this {0} it will be removed from the project along with all the associated codings.",
        delete: "Delete",
        remove: "Remove",
        reset: "Reset",
        cancel: "Cancel",
      },
      confirm_update: {
        update_articles: "Update Articles",
        update_articles_error: "You must set at least one field."
      },
      confirm_save: {
        title: "Confirm Save",
        message: "Are you sure you want to make changes to '{name}'?",
      },
      confirm_remove: {
        title: "Remove from group",
        message: "Do you want to remove the selected articles from group \"{name}\"?"
      },
      search: {
        no_records: 'No records'
      },
      image_upload: {
        success: 'Your image has been uploaded.',
        error: 'Image upload failed. Please try again.'
      },
      whatsapp: {
        contact_delete_success: 'Successfully deleted whatsapp contact',
        contact_delete_error: 'Failed to delete whatsapp contact',
        contact_update_success: 'Successfully updated whatsapp contact',
        contact_update_error: 'Failed to update whatsapp contact',
        contact_insert_success: 'Successfully saved whatsapp contact',
        contact_insert_error: 'Failed to save whatsapp contact',
        contact_list_delete_success: 'Successfully deleted whatsapp contact list',
        contact_list_delete_error: 'Failed to delete whatsapp contact list',
        contact_list_edit_success: 'Contact list updated successfully',
        contact_list_validate_error: 'Please enter all fields',
        contact_list_create_success: 'Whatsapp contact list successfully created',
        contact_list_contact_delete_success: 'Contact successfully removed from contact list',
        contact_list_contact_insert_success: 'Contact successfully added to the contact list',
        contact_list_contact_delete_error: 'Failed to remove contact from contact list',
        contact_resend_opt_in_success: 'Successfully sent opt in message to contact',
        contact_resend_opt_in_error: 'Contact has already responded to opt in message',
        contact_already_added_to_contact_list: '{first_name} {last_name} already added to contact list.',
        contact_list_already_added_to_contact: '{name} already added to contact.'
      },
      mobile_app: {
        contact_list_delete_success: 'Successfully deleted mobile app contact list',
        contact_list_delete_error: 'Failed to delete mobile app contact list',
        contact_list_edit_success: 'Contact list updated successfully',
        contact_list_validate_error: 'Please enter all fields',
        contact_list_create_success: 'Mobile app contact list successfully created',
        contact_list_contact_delete_success: 'Contact successfully removed from contact list',
        contact_list_contact_insert_success: 'Contact successfully added to the contact list',
        contact_list_contact_delete_error: 'Failed to remove contact from contact list',
        contact_resend_opt_in_success: 'Successfully sent opt in message to contact',
        contact_resend_opt_in_error: 'Contact has already responded to opt in message',
        contact_already_added_to_contact_list: '{first_name} {last_name} already added to contact list.',
        contact_list_already_added_to_contact: '{name} already added to contact.'
      },
      auth: {
        labels: {
          email: 'Email',
          password: 'Password',
          code: 'Code',
          new_password: 'New password',
          confirm_password: 'Confirm password'
        },
        actions: {
          sign_in: 'Sign In',
          signing_in: 'Signing in...',
          forgot_password: 'Forgot password?',
          send_reset_link: 'Send reset link',
          sending: 'Sending...',
          back_to_sign_in: 'Back to sign in',
          reset_password: 'Reset password',
          saving: 'Saving...'
        },
        info: {
          reset_email_sent: 'If that email is registered, you will receive reset instructions shortly.'
        },
        profile_password: {
          required_placeholder: 'Required',
          rules: {
            complexity: 'Your password must be Strong or Very Strong. Use at least 12 characters, uppercase, lowercase and a number.',
            company_name: 'Your new password must not include company name'
          },
          actions: {
            change: 'Change Password',
            changing: 'Changing Password...'
          },
          errors: {
            change_failed: 'Could not change password. Try again.',
            too_weak: 'Your password is not strong enough. Make it Strong or Very Strong to continue.'
          }
        },
        password_strength: {
          generate: {
            action: 'Use a random strong password',
            copied: 'A strong password was generated and copied to your clipboard.',
            copy_failed: 'A strong password was generated. Copy it from the field before saving.'
          },
          levels: {
            very_weak: 'Very Weak',
            weak: 'Weak',
            fair: 'Fair',
            strong: 'Strong',
            very_strong: 'Very Strong'
          },
          requirements: {
            min_length: 'At least 12 characters',
            uppercase: 'Contains an uppercase letter (A)',
            lowercase: 'Contains a lowercase letter (a)',
            number: 'Contains a number',
            special: 'Contains a special character'
          }
        },
        errors: {
          unexpected_response: 'Unexpected response from server.',
          invalid_email_or_password: 'Invalid email or password',
          sign_in_failed: 'Could not sign in. Try again.',
          send_reset_email_failed: 'Could not send reset email. Try again later.',
          missing_reset_token: 'This reset link is missing a token. Request a new reset email.',
          reset_password_failed: 'Could not reset your password. Try again or request a new link.',
          password_too_weak: 'Your password is not strong enough. Make it Strong or Very Strong to continue.',
          password_confirmation_mismatch: 'Password confirmation does not match.'
        }
      },
      coding:{
        title: "Organizations Category Change",
        message: "Changing organization category will reset all organizations for this project!"
      },
      users: {
        user_update_success: 'Successfully updated user'
      },
      acls: {
        permissions_update_success: 'Successfully updated Permissions'
      }
    }
  }
}

module.exports.messages = messages;